/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.business.internal

import features.business.models.Business
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class BusinessServiceImpl : BusinessService {

    private val businessRequest = BusinessRequest()

    override suspend fun getBusiness(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<Business> {
        return businessRequest.getBusiness(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
